<template>
  <div id="PIM">
    <div class="btnBoxs">
     <div class="search">
      <div>
        <span style="font-size: 0.75rem;">匹配模式:</span>
      <el-select v-model="pattern" filterable placeholder="请选择" style="width: 300px;" size='mini'>
        <el-option v-for="(item,index) in patternAll" :key="index" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      </div>
      <div style="margin-left:60px">
        <span style="font-size: 0.75rem;">关键字:</span>
      <el-input v-model="keywords" autocomplete="off" style="width: 200px;" size='mini'>
      </el-input>
      </div>
      <div class="btn">
        <el-button type="primary" size='mini'  icon="el-icon-search" @click="pagefeed">搜 索</el-button>
        <el-button  size='mini'  icon="el-icon-circle-close" @click=" keywords = '' ">清 空</el-button>
    </div>
     </div>
    </div>
    <el-button @click="addClick()" type="primary" icon="el-icon-edit" size="mini">添加</el-button>
    <!-- <el-button @click="delentClick()" type="danger" icon="el-icon-delete" size="small">删 除</el-button> -->
    <el-table :data="tableData" border style="width: 100%" :height="TableHeight" v-loading="loading"  element-loading-text="拼命加载中">
      <el-table-column prop="GZL_ROLE_id_PK" label="ID"  width="150" align="center">
      </el-table-column>
      <el-table-column prop="name" label="姓名">
      </el-table-column>
      <el-table-column prop="description" label="描述"  show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="rule_FK" label="权限ID" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="操作"align="center">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="primary" icon="el-icon-edit" size="mini">修改</el-button>
          <el-button @click="delentClick(scope.row)" type="danger" icon="el-icon-delete" size="mini">删 除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog v-dialogDrag  title="授权" :visible.sync="dialogVisible" width="30%">
      <el-form ref="form" :model="sizeForm" label-width="80px" size="mini">
        <el-form-item label="角色" style="display: flex;">
          <el-input v-model="sizeForm.name" placeholder="请输入角色名"></el-input>
        </el-form-item>
        <el-form-item label="菜单授权">
          <el-tree :data="child" show-checkbox :props="defaultProps" node-key="id" @check-change="handleCheckChange"
            ref='tree'>
          </el-tree>
        </el-form-item>
        <el-form-item label="角色描述">
          <el-input type="textarea" v-model="sizeForm.description"></el-input>
        </el-form-item>
        <el-form-item size="large">
          <el-button @click="Destroy()">取 消</el-button>
          <el-button type="primary" @click="confirm()" v-if="confirmTF">确 定</el-button>
          <el-button type="primary" @click="confirmON()" v-else>确 定</el-button>
        </el-form-item>


      </el-form>
    </el-dialog>
    <div class="block">
      <!-- 分页 -->
      <el-pagination class="pagination" @current-change="currentChangeHandle" background :current-page="currentPage1"
        :page-size="pageSize" layout="prev, pager, next, slot, jumper" :total="currentPage4">
        <!-- <span style="width: 100px;">
          <el-input v-model.number="currentPage" @input="handlePageSize" size='mini'></el-input>条/页
        </span> -->
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import {
    pagepower,
    userlevelpages
  } from '../../static/API/API.js'
  const cityOptions = [];
  export default {
    data() {
      return {
        sizeForm: {
          name: '',
          rule_FK: '',
          description: ''
        },
        //
        checkAll: false,
        checkedCities: [],
        cities: cityOptions,
        isIndeterminate: true,
        //
        tableData: [],
        currentPage4: 0,
        currentPage1: 1,
        currentPage: 10,
        pageSize: 1,
        keywords: '',
        pattern: '',
        patternAll: [{
          value: 'name',
          label: '角色名'
        },],
        dialogVisible: false,
        confirmTF: false,
        child: [],
        children: [],
        value: '',
        defaultProps: {
          multiple: true,
          children: 'child',
          label: 'name'
        },
        loading:false,
        TableHeight:490
      }
    },
    methods: {
      // 选中菜单
      // :default-expanded-keys="checkedCities" :default-checked-keys="checkedCities"
      handleCheckChange(data, checked, indeterminate) {
        //获取所有选中的节点 start
        // let res = this.$refs.tree.getCheckedNodes()
        // let arrDeptId = []
        // res.forEach((item) => {
        //   console.log(item)
        //   arrDeptId.push(item.id)
        // })
        // console.log(arrDeptId)
        this.children = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())
          // console.log(this.children)

      },
      //添加确定
      confirm() {
        let params = new URLSearchParams()
        params.append('ope_type', 'create')
        params.append('name', this.sizeForm.name)
        params.append('power', this.children)
        params.append('description', this.sizeForm.description)
        this.$axios.post(pagepower,params).then(res => {
          this.$message({
            message: res.data,
            type: 'success',
            duration: 1000,
            showClose: true,
          });
          this.pagefeed()
          this.Destroy()
          // this.menuBar()
        })
        console.log(this.sizeForm)
        this.dialogVisible = false

      },
      // 修改确定
      confirmON() {
        console.log(this.sizeForm);
        let params = new URLSearchParams()
        params.append('ope_type', 'update')
        params.append('role_id', this.sizeForm.GZL_ROLE_id_PK)
        params.append('name', this.sizeForm.name)
        params.append('description', this.sizeForm.description)
        params.append('power', this.children)
        this.$axios.post(pagepower,params).then(res => {
          this.$message({
            message: res.data,
            type: 'success',
            duration: 1000,
            showClose: true,
          });
          this.pagefeed()
          this.Destroy()
        })
        this.dialogVisible = false

      },
      /* 添加角色*/
      addClick() {
        this.dialogVisible = true
        this.confirmTF = true
        this.sizeForm = {
          name: '',
          rule_FK: '',
          description: ''
        }
      },
      // 修改角色信息
      handleClick(row) {
        this.confirmTF = false
        this.sizeForm = row
        this.checkedCities = row.rule_FK.split(',')
        this.dialogVisible = true
        let _this = this
        setTimeout(function() {
          _this.checkedCities.forEach(i => {
            console.log(i,'3333333');
            var node = _this.$refs.tree.getNode(i);
              console.log(node)
            if (node&&node.isLeaf) {
              _this.$refs.tree.setChecked(node,true);
              //是否设置子节点，默认为false，利用tree组件渲染后带有的isLeaf(是否为叶子节点)属性，如果为叶子节点就选中。利用tree的API就实现了正确的回显效果
            }
            // _this.$refs.tree.setCheckedKeys(_this.checkedCities);
          })
        }, 0)
      },
      // 删除
      delentClick(row) {
        let params = new URLSearchParams()
        params.append('ope_type', 'delete')
        params.append('role_id', row.GZL_ROLE_id_PK)
        this.$axios.post(pagepower,params).then(res => {
          this.$message({
            message: res.data,
            type: 'success',
            duration: 1000,
            showClose: true,
          });
          this.pagefeed()
        })
      },
      pagefeed() {
        this.loading = true
        let params = new URLSearchParams()
        params.append('page_size', this.currentPage)
        params.append('page_number', this.currentPage1)
        params.append('keyword', this.keywords)
        this.$axios.get(pagepower, {
          params
        }).then(res => {
          console.log(res);
          this.tableData = res.data.result
          this.currentPage4 = Number(res.data['page_total'])
          setTimeout(() => {
            this.loading = false
          }, 300);
        })
        this.getMenu()
      },
      getMenu(){
        this.$axios.get(userlevelpages, {
        }).then(res => {
          console.log(res.data,'res.data');
          this.child = res.data
        })
      },
      // 改变当前所在页
      currentChangeHandle(val) {
        this.currentPage1 = val
        this.pagefeed()
      },
      // 监听pageSize文本框的变化，当pageSize为空时，设置pageSize的值为0，以防报错
      handlePageSize() {
        if (!this.pageSize) {
          this.pageSize = 7
          // this.pagefeed()
        } else {
          // this.pagefeed()
        }
      },
      Destroy() {
        var _this = this
        _this.checkedCities = []
        _this.tableData = []
        _this.cities = []
        _this.dialogVisible = false
        console.log(this.cities)
        this.pagefeed()
      },
      getHeight(){
    //动态计算表格高度
    this.$nextTick(()=>{
      let windowHeight = document.documentElement.clientHeight || document.bodyclientHeight;
    this.TableHeight = windowHeight - 262;//数值"140"根据需要调整
    })
      },
    },
    created () {
    window.addEventListener('resize', this.getHeight)
  },
    destroyed () {
    window.removeEventListener('resize', this.getHeight)
  },
    mounted() {
      this.companyid =sessionStorage.getItem('companyid')
      this.cities = []
      this.checkedCities = []
      this.pagefeed()
      this.getHeight()
    },
  }
</script>

<style scoped>
  .block {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }

  .el-form-item__label {
    width: 8.75rem !important;
  }

  .select {
    width: 25rem !important;
  }

  .el-select-dropdown {
    max-width: 2.5rem;
    width: 25rem;
    transform-origin: center top;
    z-index: 2009;
    position: absolute;
    top: 28.5625rem;
    left: 57.25rem
  }

  .el-select-dropdown__item {
    overflow: visible;
  }

  .el-popper[x-placement^=top] {
    margin-bottom: 0.75rem;
    width: 25rem !important;
    background-color: red;
  }
  .btnBoxs{
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
  }
  .search{
    display: flex;
    align-items: center;
  }
  .btn{
    display: flex;
    align-items: center;
    margin-left: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/PIM.vue